import { AutopaySettings } from "./autopay";

export class Portfolio {
	portfolioKey: any;
	name: any;
	settings: any;
	merchantSettings: any;
	paymentMethods: any;
	autopaySettings: AutopaySettings;
	ezPayMerchants: any;

	constructor(portfolio) {
		if (portfolio.key) {
			Object.assign(this, portfolio);
		} else {
			this.portfolioKey = portfolio.portfolioKey;
			this.name = portfolio.portfolioName;
			this.settings = {};
			this.merchantSettings = {};
			if (portfolio.portalSettings) {
				Object.assign(this.settings, JSON.parse(portfolio.portalSettings));
			}
			if (portfolio.merchantSettings) {
				Object.assign(this.merchantSettings, portfolio.merchantSettings);
			}
			if (portfolio.ezPayMerchants) {
				this.ezPayMerchants = portfolio.ezPayMerchants;
			}
			this.requireProperty(this, 'paymentTypes');
			this.requireProperty(this, 'paymentMethods');

			if (this.merchantSettings) {
				this.paymentMethods.allowAch = this.hasSettings && this.settings.paymentMethods.allowAch && this.merchantSettings.canProcessAch;
				this.paymentMethods.allowCreditCard = this.hasSettings && this.settings.paymentMethods.allowCreditCard && this.merchantSettings.canProcessCreditCard;
				this.paymentMethods.allowApplePay = this.hasSettings && this.settings.paymentMethods.allowApplePay && this.merchantSettings.canProcessApplePay;
				this.paymentMethods.acceptsDebit = this.merchantSettings.acceptsDebit;
				this.paymentMethods.acceptsCredit = this.merchantSettings.acceptsCredit;
			}

			this.autopaySettings = portfolio.autopaySettings;
		}
	}

	get hasSettings() {
		return (this.settings && this.settings.paymentMethods);
	}

	requireProperty(object, fieldName) {
		if (!object.hasOwnProperty(fieldName)) {
			object[fieldName] = {};
		}
	}
}
